import { render, staticRenderFns } from "./Assets.vue?vue&type=template&id=55fc08e4&scoped=true&"
import script from "./Assets.vue?vue&type=script&lang=js&"
export * from "./Assets.vue?vue&type=script&lang=js&"
import style0 from "./Assets.vue?vue&type=style&index=0&id=55fc08e4&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55fc08e4",
  null
  
)

export default component.exports